import Avatar from "@/app/components/Avatar"
import { getBlogBySlug } from "@/lib/api/blogs"
import { getBlogUrl } from "@/lib/utils/blog"
import Link from "next/link"
import { cn } from "@/lib/utils"

/**
 * Shows a blog logo that can be clicked on.
 *
 * Note that this ONLY WORKS AS A SERVER COMPONENT. You cannot use this from the client
 * or you will end up with an infinite loop of re-renders and errors around using async/await
 * in client-side code which is not supported in Next.
 */
export async function BlogLogo({
  params,
  className,
}: {
  params: Promise<{ blogSlug: string }>
  className?: string
}) {
  const { blogSlug } = await params

  const blog = await getBlogBySlug(blogSlug)

  const { customDomainOrRelativeUrl } = getBlogUrl(blog)

  return (
    <>
      {blog.logo_url && (
        <Link
          href={customDomainOrRelativeUrl as string}
          prefetch
          className="z-50"
        >
          <BlogLogoImage
            src={blog.logo_url}
            alt={blog?.name}
            className={className}
          />
        </Link>
      )}
    </>
  )
}

export function BlogLogoImage({
  src,
  alt,
  className,
  size = 92,
}: {
  src: string
  alt: string
  className?: string
  size?: number
}) {
  return (
    <Avatar
      src={src}
      alt={alt}
      size={size}
      className={cn("h-10 w-10 rounded-md", className)}
      imageClassName="rounded-md"
      noFallback
    />
  )
}
